/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Booking_Calendar_Day_TodayInputs */

const en_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Today, ${i?.date}`)
};

const es_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hoy, ${i?.date}`)
};

const de_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Heute, ${i?.date}`)
};

const zh_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`今天，${i?.date}`)
};

const ar_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`اليوم، ${i?.date}`)
};

const fr_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aujourd'hui, ${i?.date}`)
};

const vi_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hôm nay, ${i?.date}`)
};

const sw_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leo, ${i?.date}`)
};

const th_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`วันนี้ ${i?.date}`)
};

const bs_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Danas, ${i?.date}`)
};

const ja_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`今日、${i?.date}`)
};

const ko_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`오늘, ${i?.date}`)
};

const pt_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hoje, ${i?.date}`)
};

const it_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oggi, ${i?.date}`)
};

const sv_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I dag, ${i?.date}`)
};

const nl_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vandaag, ${i?.date}`)
};

const da_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I dag, ${i?.date}`)
};

const nb_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I dag, ${i?.date}`)
};

const fi_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tänään, ${i?.date}`)
};

const pl_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dzisiaj, ${i?.date}`)
};

const ru_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сегодня, ${i?.date}`)
};

const tr_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bugün, ${i?.date}`)
};

const hi_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आज, ${i?.date}`)
};

const id_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hari ini, ${i?.date}`)
};

const ms_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hari ini, ${i?.date}`)
};

const cs_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dnes, ${i?.date}`)
};

const el_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Σήμερα, ${i?.date}`)
};

const he_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`היום, ${i?.date}`)
};

const af_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vandag, ${i?.date}`)
};

const hu_booking_calendar_day_today = /** @type {(inputs: Booking_Calendar_Day_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ma, ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Today, {date}" |
*
* @param {Booking_Calendar_Day_TodayInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_calendar_day_today = /** @type {((inputs: Booking_Calendar_Day_TodayInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Calendar_Day_TodayInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_calendar_day_today(inputs)
	if (locale === "de") return de_booking_calendar_day_today(inputs)
	if (locale === "zh") return zh_booking_calendar_day_today(inputs)
	if (locale === "ar") return ar_booking_calendar_day_today(inputs)
	if (locale === "fr") return fr_booking_calendar_day_today(inputs)
	if (locale === "vi") return vi_booking_calendar_day_today(inputs)
	if (locale === "sw") return sw_booking_calendar_day_today(inputs)
	if (locale === "th") return th_booking_calendar_day_today(inputs)
	if (locale === "bs") return bs_booking_calendar_day_today(inputs)
	if (locale === "ja") return ja_booking_calendar_day_today(inputs)
	if (locale === "ko") return ko_booking_calendar_day_today(inputs)
	if (locale === "pt") return pt_booking_calendar_day_today(inputs)
	if (locale === "it") return it_booking_calendar_day_today(inputs)
	if (locale === "sv") return sv_booking_calendar_day_today(inputs)
	if (locale === "nl") return nl_booking_calendar_day_today(inputs)
	if (locale === "da") return da_booking_calendar_day_today(inputs)
	if (locale === "nb") return nb_booking_calendar_day_today(inputs)
	if (locale === "fi") return fi_booking_calendar_day_today(inputs)
	if (locale === "pl") return pl_booking_calendar_day_today(inputs)
	if (locale === "ru") return ru_booking_calendar_day_today(inputs)
	if (locale === "tr") return tr_booking_calendar_day_today(inputs)
	if (locale === "hi") return hi_booking_calendar_day_today(inputs)
	if (locale === "id") return id_booking_calendar_day_today(inputs)
	if (locale === "ms") return ms_booking_calendar_day_today(inputs)
	if (locale === "cs") return cs_booking_calendar_day_today(inputs)
	if (locale === "el") return el_booking_calendar_day_today(inputs)
	if (locale === "he") return he_booking_calendar_day_today(inputs)
	if (locale === "af") return af_booking_calendar_day_today(inputs)
	if (locale === "hu") return hu_booking_calendar_day_today(inputs)
	return en_booking_calendar_day_today(inputs)
});